(ns com.theplantscape.plant-web.pages.diagram.list
  (:require
   [cljs.core.async :refer [<! go]]
   [com.theplantscape.web-ui.tailwind.ensemble :refer [form]]
   [com.theplantscape.local-store.ensemble :as db :refer [diagrams]]
   [com.theplantscape.plant-web.api.diagrams :as d]
   [com.theplantscape.plant-web.components.forms.core :refer [update-atom-hm]]
   [com.theplantscape.plant-web.components.images :refer [build-image-path]]
   [com.theplantscape.plant-web.components.tailwind.buttons :refer [button button-progress-async]]
   [com.theplantscape.plant-web.components.tiles :refer [tile]]
   [com.theplantscape.plant-web.draw.constants :refer [do-plant-img]]
   [com.theplantscape.plant-web.draw.db :refer [select-bind]]
   [com.theplantscape.plant-web.draw.db-store :refer [restore-database]]
   [com.theplantscape.plant-web.draw.state :refer [app-state build-api-url authed?]]
   [com.theplantscape.plant-web.draw.ui-form :as f]
   [com.theplantscape.web-ui.tailwind.ensemble
    :refer [grid-layout-one ui-btn-action ui-btn-link]]
   [com.theplantscape.web-ui.tailwind.lists :refer [simple-list]]
   [reagent.core :as r]
   [reitit.frontend.easy :as rfe]))

(def image-path (partial build-image-path do-plant-img))

(defn load-diagram [{:keys [id]}]
  (prn "### load diagram path id " id)
  (restore-database db/diag id))

(defn diagram-list []
  (go (let [response (<! (d/fetch-user-diagram-list {:list "all"}))]
        (if (first response)
          (swap! app-state assoc-in [:diagrams] (second response))
          (swap! app-state assoc-in [:errors] (second response))))))

(defn ui-form-create-new-diagram []
  (let [values (r/atom {:values {:diagram|title "My Garden"}})
        form-on-change (partial update-atom-hm values)]
    (fn []
      [:div
       (when (authed?)
         [form
          {}
          [:<>
           [f/ui-input-inline-fn
            "diagram|title"
            {:label "Create Diagram"
             :label-classes "m-2"
             :input-classes "m-2"
             :default-value-fn (-> @values :values :diagram|title)
             :on-change-fn form-on-change}]
           [button
            {:on-click (fn [evt] (.preventDefault evt)
                         (d/create-user-diagram (:values @values)))}
            "Create"]]]

         #_[:button.dark-gray.ml3.pv2.ph3.bg-blue.hover-bg-near-white.ba.b--dark-blue.br2.shadow-1
            {:on-click (fn [evt] (.preventDefault evt)
                         (add-new-plant-list (:values @values) prn)
                         (fetch-users-lists #(swap! app-state assoc :user-plant-lists %)))} "Add"])])))

(defn fetch-diagrams [])

(defn fetch-row [row])

(defn clean-diagram-keys [diagram]
  (-> diagram
      (dissoc  :xt/id)
      (dissoc  :diagram/title)
      (dissoc  :diagram/description)
      (dissoc  :diagram/user-id)))

(defn page-diagrams [_]
  (let [users-diagram-list (r/cursor app-state [:diagrams])
        diagram-stats-seq (select-bind nil diagrams)]
    (fn [_]
      [:div
       (if @users-diagram-list
         (grid-layout-one
          [ui-form-create-new-diagram]
          (into []
                (->> @users-diagram-list
                     (map (fn [{:keys [diagram detail]}]
                            [:div.flex.flex-1.flex-col.justify-between.h-full
                             [:h3.m-4.text-lg.font-semibold (:diagram/title diagram)]
                             [:div.m-4.flex.flex-row.grow
                              {:key (:xt/id diagram)
                               :class "hover:bg-green-100"}
                              [tile {:title (str (:diagram/title diagram))
                                     :image
                                     (@build-api-url "/api/v2/diagrams/png/" (:xt/id diagram))
                                     :on-click (fn click-restore-db [e]
                                                 prn
                                                 #_(restore-database db/diag (:xt/id diagram)))
                                     #_#_:remove-fn (fn click-remove-diagram [e]
                                                      (d/delete-user-diagram
                                                       (:xt/id diagram)
                                                       diagram-list))
                                     :link (rfe/href :diagram {:id (str (:xt/id diagram))})}]
                              [:div.ml-4.w-48
                                        ;[:h3 (:diagram/title diagram)]
                               [:p (get diagram :diagram/description "")]
                               [simple-list
                                (clean-diagram-keys diagram)
                                (fn [item] [:div (first item) " " (second item) " plants"])]]]
                             [:div.m-4.flex.flex-row
                              #_[:div.mr-4 
                               #_[button-progress-async
                                "Delete"
                                {:on-click (partial d/delete-user-diagram-async (:xt/id diagram))
                                 :on-complete (fn [response] (diagram-list))}]]
                              #_[ui-btn-action
                               "delete"
                               (fn click-remove-diagram [e]
                                 (.preventDefault e)
                                 (d/delete-user-diagram
                                  (:xt/id diagram)
                                  diagram-list))]
                              [ui-btn-link
                               {:text "calendar"
                                :href (rfe/href :schedule {:diagram-id (:xt/id diagram)})}]
                              [ui-btn-link
                               {:text "share"
                                :href (@build-api-url "/api/v2/diagrams/png/" (:xt/id diagram))}]]])))))
         "No Diagrams")])))
